export enum ExternalUrls {
  IMAGE_VIEWER_SIDE_COMPONENT = 'trailer-image-gallery/',
}
